import { useTranslations } from 'next-intl';

import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { useFormattedDate } from '@commons/hooks/useFormattedDate';
import { Link } from '@commons/i18n/navigation';
import { CARD_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { IntelligenceNodeProps } from '.';

/**
 * Intelligence node component for the Card display type.
 */

const IntelligenceNodeCard = (props: IntelligenceNodeProps) => {
  const t = useTranslations('nodes.intelligence');

  const { image, title, summary, alias, date } = props;

  const formattedDate = useFormattedDate(date);

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={CARD_DISPLAY_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={CARD_DISPLAY_IMAGE_SIZES} />
  );

  return (
    <Link href={alias}>
      <Card gap="md" justify="space-between" hasBorder>
        <Flex gap="xs" direction="column">
          <Card.Overlay>{renderedImage}</Card.Overlay>
          <Text as="h6" level="label-lg" transform="uppercase" marginBottom="none">
            {t('label')}
          </Text>
          <Card.Title>{title}</Card.Title>
          {summary && <Text marginBottom="none">{summary}</Text>}
        </Flex>
        <Text level="body-xs" transform="uppercase" marginBottom="none">
          {formattedDate}
        </Text>
      </Card>
    </Link>
  );
};

export default IntelligenceNodeCard;
